import { AppThunk } from '../../../store/rootReducer';
import { Cluster } from '../clustering.types';
import { cleanBeats } from './clean-beats.thunk';
import * as clusterActions from '../actions/cluster.actions';
import * as beatsActions from '../../beats/beats.actions';

export const selectNewCluster =
  (cluster: Cluster): AppThunk =>
  async (dispatch, getState) => {
    dispatch(cleanBeats());
    dispatch(beatsActions.load({ beats: cluster.beats }));
    dispatch(
      clusterActions.selectClusters({
        clusterIds: new Set([cluster.id]),
      }),
    );
  };
